import React from 'react';
import './Spinner.css';

const Spinner: React.FC = () => (
    <div className='spinner'/>
);
export default Spinner;
